import { jsx as _jsx } from "react/jsx-runtime";
import EventBusyIcon from '@mui/icons-material/EventBusy';
import EventIcon from '@mui/icons-material/Event';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import { SlotType, TableReservationEvent } from "../models/reservation/reservation.model";
import CakeIcon from '@mui/icons-material/Cake';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import PublicIcon from '@mui/icons-material/Public';
import CelebrationIcon from '@mui/icons-material/Celebration';
import SchoolIcon from '@mui/icons-material/School';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import FavoriteIcon from '@mui/icons-material/Favorite';
export var getSlotTypeIcon = function (slotType) {
    switch (slotType) {
        case SlotType.RESERVATION:
            return _jsx(EventIcon, {});
        case SlotType.SERIAL:
            return _jsx(EventRepeatIcon, {});
        case SlotType.BLOCK:
            return _jsx(EventBusyIcon, {});
        default:
            return undefined;
    }
};
export var getReservationEventIcon = function (event) {
    switch (event) {
        case TableReservationEvent.BIRTHDAY:
            return _jsx(CakeIcon, {});
        case TableReservationEvent.FAMILY_EVENT:
            return _jsx(FamilyRestroomIcon, {});
        case TableReservationEvent.COMMEMORATION:
            return _jsx(PublicIcon, {});
        case TableReservationEvent.CELEBRATION:
            return _jsx(CelebrationIcon, {});
        case TableReservationEvent.ENGAGEMENT:
            return _jsx(VolunteerActivismIcon, {});
        case TableReservationEvent.EDUCATION:
            return _jsx(SchoolIcon, {});
        case TableReservationEvent.PROMOTION:
            return _jsx(KeyboardDoubleArrowUpIcon, {});
        case TableReservationEvent.WEDDING_CEREMONY:
            return _jsx(FavoriteIcon, {});
        case TableReservationEvent.WEDDING_ANNIVERSARY:
            return _jsx(FavoriteIcon, {});
        case TableReservationEvent.OTHER:
            return _jsx(EventBusyIcon, {});
        default:
    }
};
